import script from "./ReportSphSpkView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportSphSpkView.vue?vue&type=script&setup=true&lang=js"

import "./ReportSphSpkView.vue?vue&type=style&index=0&id=64c48bf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c48bf0"]])

export default __exports__